module.exports = __webpack_public_path__ + "img/service_img4.226336ad.png";